import { SVGProps } from 'react';

const FileImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 2v4a2 2 0 0 0 2 2h4m0 9-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22m6-20H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7zm-3 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default FileImage;
